// Types
import {
  IframeErrorBuilderHandlersType,
  IframeErrorMethodsHandlersType,
} from './types/iframe-error.handlers.type';
// Utils
import { getIframeLoadErrorById, maxAttemptsOnIframeAchieved } from './utils/iframe.handlers.utils';

const catchAndManageFrameComponentErrorEventHandler = ({
  errorAttempts,
  id,
  setError,
  setErrorAttempts,
}: IframeErrorBuilderHandlersType): void => {
  maxAttemptsOnIframeAchieved(errorAttempts)
    ? setError(getIframeLoadErrorById(id))
    : setErrorAttempts(errorAttempts + 1);
};

const IframeErrorHandlers = (
  props: IframeErrorBuilderHandlersType
): IframeErrorMethodsHandlersType => ({
  handleCatchAndManageFrameComponentErrorEvent: () =>
    catchAndManageFrameComponentErrorEventHandler(props),
});

export { IframeErrorHandlers };
